import { api } from './api'

export type SubscriptionFrequency = 'weekly' | 'monthly' | 'quarterly'

export interface ClinicProgramOption {
  id: string
  clinic_id: string
  program_id: string
  label: string
  description?: string | null
  program_price: number
  clinic_facilitation_fee: number
  platform_program_fee?: number
  is_subscription: boolean
  subscription_frequency?: SubscriptionFrequency | null
  includes_services?: string[]
  intake_form_type?: string | null
  sort_order?: number | null
  is_deleted?: boolean
  created_at: string
  updated_at: string
}

export interface CreateOptionPayload {
  label: string
  description?: string
  program_price: number
  clinic_facilitation_fee: number
  includes_services?: string[]
  is_subscription: boolean
  subscription_frequency?: SubscriptionFrequency
  sort_order?: number
  intake_form_type?: 'trt' | 'hrt' | 'glp1' | 'peptide' | 'nad' | 'fertility' | 'general' | null
}

export type UpdateOptionPayload = Partial<CreateOptionPayload>

const optionsPath = (clinicId: string, programId: string) =>
  `/clinic/${clinicId}/programs/${programId}/options`

export const getClinicProgramOptions = async (
  clinicId: string,
  programId: string
): Promise<{ options: ClinicProgramOption[] }> => {
  const response = await api.get(optionsPath(clinicId, programId))
  return response?.data ?? response ?? { options: [] }
}

export const createClinicProgramOption = async (
  clinicId: string,
  programId: string,
  data: CreateOptionPayload
): Promise<{ option: ClinicProgramOption }> => {
  const response = await api.post(optionsPath(clinicId, programId), data)
  return response?.data ?? response
}

export const updateClinicProgramOption = async (
  clinicId: string,
  programId: string,
  optionId: string,
  data: UpdateOptionPayload
): Promise<{ option: ClinicProgramOption }> => {
  const response = await api.put(`${optionsPath(clinicId, programId)}/${optionId}`, data)
  return response?.data ?? response
}

export const deleteClinicProgramOption = async (
  clinicId: string,
  programId: string,
  optionId: string
): Promise<void> => {
  await api.delete(`${optionsPath(clinicId, programId)}/${optionId}`)
}
